/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for NaturePieceIdentiteResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, NaturePieceIdentiteDTO } from "../models";

@Injectable({ providedIn: "root" })
export class NaturePieceIdentiteResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findAllEnseignant7(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant7(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant7(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant7(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant8(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant8(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant8(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant8(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant9(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant9(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant9(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant9(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('put', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant11(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant11(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant11(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant11(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant10(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant10(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant10(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant10(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant13(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant13(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant13(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant13(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findAllEnseignant12(observe?: 'body', options?: RequestOptions<'blob'>): Observable<Array<NaturePieceIdentiteDTO>>;
    findAllEnseignant12(observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant12(observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Array<NaturePieceIdentiteDTO>>>;
    findAllEnseignant12(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/list-natures`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
